import { IconName, TagColor } from '@billy/design-system'

import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import { CegidIntegrationStatus } from '@features/cegidIntegration/enums/cegidIntegrationStatus'
import { getLatestIntegrationStatus } from '@views/bills/utils/getLatestIntegrationStatus'

export type ReceiptTransferStatusIcon = IconName

export interface ReceiptTransferStatusBadgeConfig {
  color: TagColor
  icon: ReceiptTransferStatusIcon
  labelKey: string
  tooltipKey: string
}

const cegidIntegrationStatusToTagColor: Record<CegidIntegrationStatus, TagColor> = {
  [CegidIntegrationStatus.Failed]: 'yellow',
  [CegidIntegrationStatus.Pending]: 'neutral',
  [CegidIntegrationStatus.Processing]: 'neutral',
  [CegidIntegrationStatus.Posted]: 'neutral',
}

const cegidIntegrationStatusToIcon: Record<CegidIntegrationStatus, ReceiptTransferStatusIcon> = {
  [CegidIntegrationStatus.Failed]: 'refreshCwOff',
  [CegidIntegrationStatus.Pending]: 'clock',
  [CegidIntegrationStatus.Processing]: 'clock',
  [CegidIntegrationStatus.Posted]: 'refresh',
}

const cegidIntegrationStatusToLabelKey: Record<CegidIntegrationStatus, string> = {
  [CegidIntegrationStatus.Failed]: 'receipts.receipts_list.transfer_status.failed_sync',
  [CegidIntegrationStatus.Pending]: 'receipts.receipts_list.transfer_status.pending_sync',
  [CegidIntegrationStatus.Processing]: 'receipts.receipts_list.transfer_status.pending_sync',
  [CegidIntegrationStatus.Posted]: 'receipts.receipts_list.transfer_status.posted',
}

const cegidIntegrationStatusToTooltipKey: Record<CegidIntegrationStatus, string> = {
  [CegidIntegrationStatus.Failed]: 'receipts.receipts_list.transfer_status.tooltip.failed_sync',
  [CegidIntegrationStatus.Pending]: 'receipts.receipts_list.transfer_status.tooltip.pending_sync',
  [CegidIntegrationStatus.Processing]: 'receipts.receipts_list.transfer_status.tooltip.pending_sync',
  [CegidIntegrationStatus.Posted]: 'receipts.receipts_list.transfer_status.tooltip.posted',
}

export const getReceiptTransferStatusBadgeConfig = (
  integrationStatuses?: IntegrationStatus[],
): ReceiptTransferStatusBadgeConfig | null => {
  const integrationStatus = getLatestIntegrationStatus(integrationStatuses)

  if (!integrationStatus) {
    return null
  }

  const { status } = integrationStatus

  return {
    color: cegidIntegrationStatusToTagColor[status],
    icon: cegidIntegrationStatusToIcon[status],
    labelKey: cegidIntegrationStatusToLabelKey[status],
    tooltipKey: cegidIntegrationStatusToTooltipKey[status],
  }
}
